import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=a391e88e"
import script from "./promo.vue?vue&type=script&lang=js"
export * from "./promo.vue?vue&type=script&lang=js"
import style0 from "./promo.vue?vue&type=style&index=0&id=a391e88e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports